import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  print(event) {
    window.print()
    // Prevent window from scrolling up to top of the page when clicking on print button
    event.preventDefault()
  }
}
